<template>
    <div>
        <h2 class="text-center" label="email" label-for="email">Test Email</h2>
        <b-form-group>
            <b-form-input id="email" type="text" v-model="email"></b-form-input>
        </b-form-group>

        <b-form-group label="order_id" label-for="order_id">
            <b-form-input
                id="order_id"
                type="text"
                v-model="order_id"
            ></b-form-input>
        </b-form-group>
        <b-button class="my-4" variant="primary" @click="sendMail"
            >sendMail</b-button
        >
        <b-button class="my-4" variant="primary" @click="getStatement"
            >statement</b-button
        >
        <b-button class="my-4" variant="primary" @click="getAnalytics"
            >Analytics</b-button
        >
        <!--  <b-button class="my-4" variant="primary" @click="getPresigned">PRESIGNED</b-button>
        <b-button class="my-4" variant="primary" @click="setLocation">Set Location</b-button>-->
    </div>
</template>
<script>
import order_api from '@/api/order'
import report_api from '@/api/report'
import user_api from '@/api/user'
const AWS = require('aws-sdk')

export default {
    name: 'test',
    components: {},
    data: () => {
        return {
            email: null,
            order_id: 1,
        }
    },
    computed: {
        s_order_id() {
            return parseInt(this.order_id) || 0
        },
    },

    mounted() {
        this.$store.dispatch('orders/myorders')
    },

    methods: {
        getAnalytics() {
            report_api.getAnalytics().then(result => {
                const data = result.data.success.message
                console.log('data', JSON.stringify(data))
            })
        },
        setLocation() {
            const lat = 18.109581
            const long = -77.297508
            user_api
                .updateLocation({ lat, long })
                .then(r => console.log('results:', r))
        },

        sendMail() {
            report_api
                .sendEmailToCustomer(this.s_order_id, this.email)
                .then(r => console.log('results:', r.data.success.message))
                .catch(err => console.error(err))
        },

        getStatement() {
            report_api
                .getStatement(this.s_order_id)
                .then(r => console.log('results:', r.data.success.message))
                .catch(err => console.error(err))
        },

        async getPresigned() {
            const {
                data: {
                    success: { data },
                },
            } = await order_api.fetchPresigned('presigned', 'lovely.jpg')
            console.log('data', data)
            const { key, keyUrl, presignedUrl } = JSON.parse(data)
            console.log('credentials', { key, keyUrl, presignedUrl })
        },

        async getToken() {
            const {
                data: {
                    success: { data },
                },
            } = await order_api.fetchPresigned('token')
            console.log('data', data)
            const { key, secret, token } = JSON.parse(data)
            console.log('credentials', { key, secret, token })
            const region = 'us-east-1'
            const options = {
                //keyPrefix: "uploads/",
                region,
                accessKeyId: key,
                secretAccessKey: secret,
                sessionToken: token,
            }
            AWS.config.update(options)

            const client = new AWS.DynamoDB.DocumentClient()
            var params = {
                TableName: 'oms_location_tracking',
                Item: {
                    deviceId: 'sjkdasdjasjd',
                    timestamp: Date.now(),
                    latitude: 78.45,
                    longitude: -75.78,
                },
            }
            await client.put(params).promise()
        },
    },
}
</script>
<style></style>
